(ns app.front.view.occupancy.download
  (:require [app.front.file.download :as file-download]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-all]]
            [app.front.view.inspections.section :as inspections-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.db.entity.util :as eu]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::visits-with-permits
  (fn [[_ target-id]]
    (rf/subscribe [::inspections-section/inspections-raw target-id]))
  (fn [inspections]
    (->> inspections
         (filter #(-> % :inspection/subtype (= :inspection.subtype/occupancy)))
         (keep (fn [inspection]
                 (->> inspection
                      :entity/_parent
                      (filter #(-> % :domain/state (= :inspection.visit.state/done)))
                      (sort-by :inspection.visit/start-time)
                      last)))
         (sort-by :inspection.visit/start-time))))


(defn view [{:keys [tr]} visits-with-permits]
  (let [group-tz (<sub [::ws-subs/group-time-zone])]
    (when (seq visits-with-permits)
      [:div.mb-6
       [:h3.mb-4 (tr [:occupancy/downloads])]
       #_{:clj-kondo/ignore [:deprecated-var]}
       [ui-table/responsive-table
        {:opts (util/mmap tr)}
        [{:title (tr [:permit/permit])}
         {:title     (tr [:date/date])
          :max-width "150px"}
         {:title     (tr [:verdict/issuer])
          :max-width "250px"}]
        (for-all [{:inspection.visit/keys [start-time inspector] :as visit} visits-with-permits
                  :let [occupancy-permit-file (->> (<sub [:app.front.entities/entities
                                                          {:entity/parent (:db/id visit)
                                                           :file/category :file.category/occupancy-permit}])
                                                   eu/latest)]
                  :when occupancy-permit-file]

          {:key  (:db/id occupancy-permit-file)
           :cols [{:content [file-download/download-workspace-file-link
                             occupancy-permit-file
                             {}]}
                  {:content (date-util/date-in-tz start-time group-tz)}
                  {:content (user-model/full-name inspector)}]})]])))
